var exports = {
  "kL": "xe7b6e3d6--f8569a--container",
  "Sl": "xe7b6e3d6--f8569a--image",
  "DD": "xe7b6e3d6--f8569a--title",
  "Qq": "xe7b6e3d6--f8569a--text",
};

module.exports = exports;
